import { Button } from "@spz/ui/components/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
} from "@spz/ui/components/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@spz/ui/components/select";
import { TextField } from "@spz/ui/components/textfield";
import { useTranslation } from "react-i18next";
import { useInviteUserFormViewModel } from "../hooks/use-invite-user";

export const InviteUserContent = () => {
  const { t } = useTranslation();
  const { form, isSubmitting, accountTypeOptions, onSubmit } =
    useInviteUserFormViewModel();

  return (
    <Form {...form}>
      <form
        id="invite-user-form"
        className="space-y-4"
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <FormField
          control={form.control}
          name="email"
          render={({ field, fieldState }) => (
            <FormItem>
              <FormControl>
                <TextField
                  {...field}
                  floatingPlaceholder
                  placeholder={t("email_address_field_label")}
                  error={fieldState.error}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="firstName"
          render={({ field, fieldState }) => (
            <FormItem>
              <FormControl>
                <TextField
                  {...field}
                  floatingPlaceholder
                  placeholder={t("first_name_field_label")}
                  error={fieldState.error}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="lastName"
          render={({ field, fieldState }) => (
            <FormItem>
              <FormControl>
                <TextField
                  {...field}
                  floatingPlaceholder
                  placeholder={t("last_name_field_label")}
                  error={fieldState.error}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="accountType"
          render={({ field, fieldState }) => (
            <FormItem>
              <FormControl>
                <Select
                  value={field.value}
                  onValueChange={field.onChange}
                  defaultValue={field.value}
                >
                  <SelectTrigger
                    placeholder={t("account_type_field_label")}
                    floatingPlaceholder
                    error={fieldState.error}
                  >
                    <SelectValue />
                  </SelectTrigger>

                  <SelectContent>
                    {accountTypeOptions.map((option) => (
                      <SelectItem key={option.id} value={option.value}>
                        {option.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </FormControl>
            </FormItem>
          )}
        />

        <div className="flex flex-col items-end gap-1 ">
          <Button type="submit" disabled={isSubmitting}>
            {t("create_and_invite")}
          </Button>
        </div>
      </form>
    </Form>
  );
};
